import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "X Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M249.764 232.015c6.832 6.832 3.706 18.497-5.626 20.997a12.55 12.55 0 0 1-12.123-3.248L128 145.734 23.985 249.763c-6.832 6.832-18.497 3.706-20.997-5.626a12.55 12.55 0 0 1 3.248-12.123L110.266 128 6.237 23.985C-.596 17.153 2.53 5.488 11.862 2.988a12.55 12.55 0 0 1 12.123 3.248L128 110.266 232.015 6.237c6.832-6.832 18.497-3.706 20.997 5.626a12.55 12.55 0 0 1-3.248 12.123L145.734 128Z" }, null, -1)
  ])))
}
export default { render: render }